var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nurse-table',{attrs:{"canDelete":true,"viewRoute":"SuperAdminNurseDetails","viewDetailRoute":"SuperAdminNurseDetailView","canCreate":true,"createRoute":"SuperAdminNurseCreate","canAssignClinic":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }